/* eslint-disable */
/* tslint:disable */
/* auto-generated react proxies */
import { createReactComponent } from './react-component-lib/index.js';
import { defineCustomElements } from '../dist/loader/index.js';
defineCustomElements();
export const LdAccordion = /*@__PURE__*/ createReactComponent('ld-accordion');
export const LdAccordionPanel = /*@__PURE__*/ createReactComponent('ld-accordion-panel');
export const LdAccordionSection = /*@__PURE__*/ createReactComponent('ld-accordion-section');
export const LdAccordionToggle = /*@__PURE__*/ createReactComponent('ld-accordion-toggle');
export const LdBadge = /*@__PURE__*/ createReactComponent('ld-badge');
export const LdBgCells = /*@__PURE__*/ createReactComponent('ld-bg-cells');
export const LdBreadcrumbs = /*@__PURE__*/ createReactComponent('ld-breadcrumbs');
export const LdButton = /*@__PURE__*/ createReactComponent('ld-button');
export const LdCard = /*@__PURE__*/ createReactComponent('ld-card');
export const LdCardStack = /*@__PURE__*/ createReactComponent('ld-card-stack');
export const LdCheckbox = /*@__PURE__*/ createReactComponent('ld-checkbox');
export const LdCircularProgress = /*@__PURE__*/ createReactComponent('ld-circular-progress');
export const LdContextMenu = /*@__PURE__*/ createReactComponent('ld-context-menu');
export const LdCookieConsent = /*@__PURE__*/ createReactComponent('ld-cookie-consent');
export const LdCrumb = /*@__PURE__*/ createReactComponent('ld-crumb');
export const LdHeader = /*@__PURE__*/ createReactComponent('ld-header');
export const LdIcon = /*@__PURE__*/ createReactComponent('ld-icon');
export const LdInput = /*@__PURE__*/ createReactComponent('ld-input');
export const LdInputMessage = /*@__PURE__*/ createReactComponent('ld-input-message');
export const LdLabel = /*@__PURE__*/ createReactComponent('ld-label');
export const LdLink = /*@__PURE__*/ createReactComponent('ld-link');
export const LdLoading = /*@__PURE__*/ createReactComponent('ld-loading');
export const LdMenu = /*@__PURE__*/ createReactComponent('ld-menu');
export const LdMenuitem = /*@__PURE__*/ createReactComponent('ld-menuitem');
export const LdMenuitemGroup = /*@__PURE__*/ createReactComponent('ld-menuitem-group');
export const LdModal = /*@__PURE__*/ createReactComponent('ld-modal');
export const LdNotice = /*@__PURE__*/ createReactComponent('ld-notice');
export const LdNotification = /*@__PURE__*/ createReactComponent('ld-notification');
export const LdOption = /*@__PURE__*/ createReactComponent('ld-option');
export const LdPagination = /*@__PURE__*/ createReactComponent('ld-pagination');
export const LdProgress = /*@__PURE__*/ createReactComponent('ld-progress');
export const LdRadio = /*@__PURE__*/ createReactComponent('ld-radio');
export const LdSelect = /*@__PURE__*/ createReactComponent('ld-select');
export const LdSidenav = /*@__PURE__*/ createReactComponent('ld-sidenav');
export const LdSidenavAccordion = /*@__PURE__*/ createReactComponent('ld-sidenav-accordion');
export const LdSidenavBack = /*@__PURE__*/ createReactComponent('ld-sidenav-back');
export const LdSidenavHeader = /*@__PURE__*/ createReactComponent('ld-sidenav-header');
export const LdSidenavHeading = /*@__PURE__*/ createReactComponent('ld-sidenav-heading');
export const LdSidenavNavitem = /*@__PURE__*/ createReactComponent('ld-sidenav-navitem');
export const LdSidenavSeparator = /*@__PURE__*/ createReactComponent('ld-sidenav-separator');
export const LdSidenavSlider = /*@__PURE__*/ createReactComponent('ld-sidenav-slider');
export const LdSidenavSubnav = /*@__PURE__*/ createReactComponent('ld-sidenav-subnav');
export const LdSidenavToggleOutside = /*@__PURE__*/ createReactComponent('ld-sidenav-toggle-outside');
export const LdSlider = /*@__PURE__*/ createReactComponent('ld-slider');
export const LdSrLive = /*@__PURE__*/ createReactComponent('ld-sr-live');
export const LdSrOnly = /*@__PURE__*/ createReactComponent('ld-sr-only');
export const LdStep = /*@__PURE__*/ createReactComponent('ld-step');
export const LdStepper = /*@__PURE__*/ createReactComponent('ld-stepper');
export const LdSwitch = /*@__PURE__*/ createReactComponent('ld-switch');
export const LdSwitchItem = /*@__PURE__*/ createReactComponent('ld-switch-item');
export const LdTab = /*@__PURE__*/ createReactComponent('ld-tab');
export const LdTable = /*@__PURE__*/ createReactComponent('ld-table');
export const LdTableBody = /*@__PURE__*/ createReactComponent('ld-table-body');
export const LdTableCaption = /*@__PURE__*/ createReactComponent('ld-table-caption');
export const LdTableCell = /*@__PURE__*/ createReactComponent('ld-table-cell');
export const LdTableCol = /*@__PURE__*/ createReactComponent('ld-table-col');
export const LdTableColgroup = /*@__PURE__*/ createReactComponent('ld-table-colgroup');
export const LdTableFoot = /*@__PURE__*/ createReactComponent('ld-table-foot');
export const LdTableHead = /*@__PURE__*/ createReactComponent('ld-table-head');
export const LdTableHeader = /*@__PURE__*/ createReactComponent('ld-table-header');
export const LdTableRow = /*@__PURE__*/ createReactComponent('ld-table-row');
export const LdTableToolbar = /*@__PURE__*/ createReactComponent('ld-table-toolbar');
export const LdTablist = /*@__PURE__*/ createReactComponent('ld-tablist');
export const LdTabpanel = /*@__PURE__*/ createReactComponent('ld-tabpanel');
export const LdTabpanellist = /*@__PURE__*/ createReactComponent('ld-tabpanellist');
export const LdTabs = /*@__PURE__*/ createReactComponent('ld-tabs');
export const LdToggle = /*@__PURE__*/ createReactComponent('ld-toggle');
export const LdTooltip = /*@__PURE__*/ createReactComponent('ld-tooltip');
export const LdTypo = /*@__PURE__*/ createReactComponent('ld-typo');
